import moment from 'moment';
import { REPORT_TIME_FORMAT } from './constants';

export const getUTCOffset = (date = new Date()) => moment(date).utcOffset() * 60000;

export const utcOffset = getUTCOffset();

export const formatReportDate = ms => moment(ms - getUTCOffset(ms)).format(REPORT_TIME_FORMAT);
